import { useEffect } from 'react'
import { buildLandingTrackingPayload, trackLandingEvent } from '@/lib/landing-tracking'

export function useLandingCampaignPageView(campaignId: number | null | undefined): void {
  useEffect(() => {
    if (campaignId == null || campaignId <= 0) {
      return
    }

    const payload = buildLandingTrackingPayload(campaignId, 'page_view')
    void trackLandingEvent(campaignId, payload).catch(() => undefined)
  }, [campaignId])
}
